import * as React from 'react'
import './Text.css'
import * as _ from 'lodash'

// import ReactMarkdown from 'react-markdown'
import marked from 'marked'

import {Controlled as CodeMirror} from 'react-codemirror2'
import 'codemirror/mode/markdown/markdown'
import 'codemirror/lib/codemirror.css'

import WithContextMenu from './WithContextMenu'
import * as actions from '../actions'

const renderMathInElement = require('katex/dist/contrib/auto-render')
import 'katex/dist/katex.css'

import { NetworkUser } from 'golgi'
import { standardSCU } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'

class Text extends React.Component<StepProps<Model.Text>, {
  editing: boolean
}> {

  state = {editing: false}
  displayRef = React.createRef<HTMLDivElement>()

  render() {
    return <NetworkUser debugName="Text" props={this.props} state={this.state} render={() => {
      const {stepC: textC, stepsC} = this.props
      const {editing} = this.state

      const html = (marked as any)(textC.select('source').get())

      return <div className="Text">
        <WithContextMenu menuMaker={() => [{
          type: 'heading',
          heading: "TEXT"
        }, {
          type: 'contents',
          contents: "Delete text",
          onClick: () => actions.act(() => {
            actions.deleteStepFromSteps(textC)
          })
        }]}>
          <div ref={this.displayRef} onClick={() => {
            this.setState({editing: true})
          }} dangerouslySetInnerHTML={{__html: html}}>
            {/* <ReactMarkdown source={text.source} /> */}
          </div>
        </WithContextMenu>
        {editing &&
          <CodeMirror
            value={textC.select('source').get()}
            options={{
              mode: 'markdown',
              theme: 'material',
              viewportMargin: Infinity,
              scrollbarStyle: "null",
              smartIndent: false,
            }}
            editorDidMount={editor => { (editor as any).focus() }}
            onBeforeChange={(_editor, _data, value) => {
              textC.select('source').set(value)
            }}
            onBlur={() => {
              this.setState({editing: false})
            }}
          />
        }
      </div>
    }} />
  }

  componentDidMount() {
    renderMathInElement(this.displayRef.current)
  }

  componentDidUpdate() {
    renderMathInElement(this.displayRef.current)
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/view/Text.tsx